<template>
  <div>
    <slot v-bind="{
      updateValidation,
      nestedValidations,
      nestedValidationsByIndex,
      validation: combinedValidation
    }" />
  </div>
</template>

<script>
import { combineValidations } from '@/utils/vuelidate'

export default {
  data: () => ({ nestedValidations: {}, combinedValidation: {} }),
  computed: {
    nestedValidationsByIndex () {
      return combineValidations(Object.values(this.nestedValidations).reduce(
        (acc, { index, $v }) => ({ ...acc, [index]: $v }),
        {}
      ))
    },
  },
  methods: {
    updateValidation (index, $v, formId) {
      if (!Object.keys($v || {}).length) {
        const { [formId]: toRemove, ...rest } = this.nestedValidations
        this.nestedValidations = rest
      } else {
        this.nestedValidations = { ...this.nestedValidations, [formId]: { $v, index } }
      }
      this.emitCombinedValidation()
    },
    emitCombinedValidation () {
      this.combinedValidation = combineValidations(
        Object.values(this.nestedValidations).map(({ index, $v }) => $v),
      )
      this.$emit('validation', this.combinedValidation)
    },
  },
}
</script>
